<!-- eslint-disable vue/no-v-html -->
<template>
  <section class="pb-16">
    <div class="px-4 pt-4">
      <user-info
        v-if="dynamicUser"
        :publish-time="dynamicContent?.publishTime || 0"
        :user="dynamicUser"
        :extinfo="extinfo"
      ></user-info>
      <div
        v-if="dynamicContent?.title"
        class="color-[#333] text-justify font-semibold leading-relaxed"
      >
        {{ dynamicContent.title }}
      </div>
      <div class="mt-2 whitespace-pre-wrap text-justify leading-relaxed">
        <span class="text-[#83C4EA]" v-html="subjectsText"></span>
        <span class="break-all text-[#333]">{{ textContent }}</span>
      </div>
      <audio-player
        v-for="item in dynamicAudios"
        :key="item.uuid"
        :duration="item.duration"
        autoplay
        :src="item.url"
        :title="item.title"
      ></audio-player>
      <open-app-btn :extinfo="extinfo">
        <component :is="'style'"
          >.subject-text { margin-top: 10px; text-align: justify; color: #83C4EA
          }</component
        >
        <div class="subject-text" v-html="subjectsText"></div>
      </open-app-btn>
      <div
        v-if="dynamicContent?.address"
        class="mt-5 flex w-full items-center bg-[#f0f0f0] px-2.5 py-1 text-sm text-[#999]"
      >
        <img class="h-4" src="@/assets/images/location.png" />
        {{ dynamicContent?.address || 'ssssss' }}
      </div>
      <div class="mt-4 text-justify text-xs leading-relaxed text-[#999]">
        本文为Fun享+用户上传发布，仅代表用户观点，用户对发布内容负责，广州日报新花城客户端仅提供信息发布平台。
      </div>
    </div>
    <comment-list />
    <comment-operate
      v-if="!browerVersion().myApp"
      :extinfo="extinfo"
      :like-num="dynamicContent?.likeCount"
    ></comment-operate>
  </section>
</template>

<script setup lang="ts">
import { browerVersion } from '@/utils';

defineOptions({ name: 'AudioDetail' });

const dynamicUser = inject<Ref<Dynamic.DynamicUser>>('dynamicUser');
const dynamicAudios = inject<Ref<Dynamic.DynamicAudio[]>>('dynamicAudios', ref([]));
const dynamicContent = inject<Dynamic.DynamicContentProps>('dynamicContent');
const dynamicSubjects = inject<Ref<Dynamic.DynamicSubject[]>>('dynamicSubjects', ref([]));

const textContent = computed(() => {
  let content = dynamicContent?.content || '';
  if (dynamicSubjects && dynamicSubjects.value) {
    dynamicSubjects.value.forEach((item) => {
      content = content.replace(item.displayName, '');
    });
  }
  return content;
});

const subjectsText = computed(() => {
  if (!dynamicSubjects.value) {
    return '';
  }
  return dynamicSubjects.value
    .map(
      (item) =>
        `<a class="subject-link" href="${import.meta.env.VITE_PROJECT_HTML_PATH}/media-subject.html?subjectId=${item.uuid}" target="_blank">${item.displayName}</a>`,
    )
    .join('');
});

const extinfo = inject<Ref<string>>('extinfo', ref(''));
</script>

<style lang="scss" scoped>
:deep(.subject-link) {
  @apply mr-2;
}
</style>
